<form #form="ngForm" novalidate>
    <div class="row">
        <div class="form-group col-12 col-sm">
            <label class="col-form-label" for="centralCompraParticipante">Central de Compras</label>
            <sgt-typeahead-cliente 
                [(ngModel)]="centralCompraParticipante" name="centralCompraParticipante" id="centralCompraParticipante"
                #typeaeadCentralCompras #centralCompraParticipanteModel="ngModel" [ngControl]="centralCompraParticipanteModel" required="required"
                [cadastroProspect]="true"
                [cadastroCliente]="true"
                [somenteCentralDeCompra]="true"
                (entitySelected)="onSelectCentralCompras()"
                (clearEntity)="onClearCentralCompras()">
            </sgt-typeahead-cliente>
            <sgt-form-control-error
                *ngIf="centralCompraParticipanteModel.errors && centralCompraParticipanteModel.errors.required && centralCompraParticipanteModel.dirty"
                msgError="A central de compras é obrigatória">
            </sgt-form-control-error>
            <div class="alert alert-info arrow-top-left" *ngIf="!centralCompraParticipante">
                Selecione a central de compras que deseja adicionar o cliente {{participante?.nome | clienteNome: participante?.nomeFantasia:participante?.codigoIntegracaoErp}} como participante
            </div>            
        </div>
    </div> 

    <ng-template [ngIf]="isLoadingCentralCompras">
        <p>Carregando Central de Compras</p>
    </ng-template>     

    <ng-template [ngIf]="isLoadedCentralCompras && centralCompras">
        <!-- Participantes -->
        <sgt-cliente-central-compra-participante-form
            #formParticipantes
            [(entities)]="centralCompras.participantes"
            [(percParticipacaoTotalCentralCompra)]="centralCompras.percParticipacaoTotal">
        </sgt-cliente-central-compra-participante-form>
    </ng-template>
</form>